import React, { useState } from 'react';
import {
  Container, Typography, Box, useMediaQuery,
  useTheme, Grid, Zoom, Paper, Card, CardContent,
  Fade, Button, CardActionArea, CardMedia
} from '@mui/material';
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Slide } from '@mui/material';
import CarouselSlider from './../components/CarouselSlider';
import { keyframes } from '@mui/system';
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { styled } from '@mui/material/styles';
import { NavLink } from 'react-router';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeopleIcon from '@mui/icons-material/People';
import { useNavigate } from 'react-router';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import BlogCardCarousel from '../components/Blogcardgrid';
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"; // Import the icon
import SavingsIcon from '@mui/icons-material/Savings';
import BlogSlider from '../components/BlogSlider';
// Define animations
// Example card wrapper (you can replace it with your own StatsCard)
const StatsCard = ({ children }) => (
  <Card sx={{ height: "100%", width: "100%", boxShadow: 3, p: 0, borderRadius: 2 }}>
    {children}
  </Card>
);

// Example icon box (centered icon container)
const IconBox = ({ children }) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 40, color: '#1565c0' }}>
    {children}
  </Box>
);

const ProgramBox = styled(Paper)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.03)',
    '& .program-overlay': {
      opacity: 1
    }
  },
  height: '300px',
  borderRadius: '12px'
}));

const ImageOverlay = styled(Box)({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)',
  padding: '20px',
  transition: 'opacity 0.3s ease-in-out',
  opacity: 0,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  '&.program-overlay': {
    opacity: 0
  }
});
const AnimatedCard = styled(Card)(({ theme }) => ({
  borderRadius: "16px",
  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "translateY(-10px)",
    boxShadow: "0px 12px 30px rgba(0, 0, 0, 0.3)"
  }
}));
const OurPrograms = ({ programs }) => {
  return (
    <Container maxWidth="lg" sx={{ mt: 0, py: 8 }}>
      {/* Title */}
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{
          fontWeight: "bold",
          background: "linear-gradient(to right, #1565c0, #4527a0)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          mb: 6
        }}
      >
        Our Programs
      </Typography>

      {/* Grid Layout for Programs */}
      <Grid container spacing={4} justifyContent="center">
        {programs.map((program) => (
          <Grid item xs={12} sm={6} md={4} key={program.name}>
            <AnimatedCard sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <CardActionArea component={NavLink} to={program.path}>
                {/* Image */}
                <CardMedia component="img" height="200" image={program.imageUrl} alt={program.name} sx={{ borderTopLeftRadius: "16px", borderTopRightRadius: "16px" }} />

                {/* Content */}
                <CardContent sx={{ textAlign: "center", flexGrow: 1 }}>
                  <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>{program.name}</Typography>
                  <Typography variant="body2" color="textSecondary">{program.description}</Typography>
                </CardContent>
              </CardActionArea>
            </AnimatedCard>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};



export default function Dashboard() {
  const stats = [
    {
      icon: <PeopleIcon sx={{ fontSize: 32 }} />,
      value: "570+",
      label: "Share Holders",
      description: "Growing community of active members"
    },
    {
      icon: <AccountBalanceWalletIcon sx={{ fontSize: 32 }} />,
      value: "₹54+ Lakhs",
      label: "Fixed Deposits",
      description: "Total fixed deposits from members"
    },
    {
      icon: <CurrencyRupeeIcon sx={{ fontSize: 32 }} />,
      value: "₹7.48 Lakhs",
      label: "Total Loans",
      description: "Supporting member growth"
    },
    {
      icon: <CreditScoreIcon sx={{ fontSize: 32 }} />,
      value: "₹50,000",
      label: "Loan Limit",
      description: "Maximum loan amount per member"
    },
    {
      icon: <CalendarTodayIcon sx={{ fontSize: 32 }} />, // New icon for the establishment year
      value: "7+ years",
      label: "18th September 2018 ",
      description: "NYCS Surat has been active since 2018"
    },
    {
      icon: <SavingsIcon sx={{ fontSize: 32 }} />,
      value: "11.82+ lakhs ",
      label: "account balance",
      description: "shareholder saving account balance"

    }
  ];
  const theme = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const programs = [
    {
      name: "Kovida",
      description: "KOVIDA has undertaken technical training for economically underprivileged youth, focusing on skill development and women empowerment.",
      imageUrl: "/Dashboard/kovida.png",
      path: '/dimensions/Kovida'
    },
    {
      name: "Sports",
      description: "Promoting physical fitness and sporting excellence through training programs and infrastructure development.",
      imageUrl: "/Dashboard/gail-raftar.png",
      path: '/dimensions/Sports'
    },
    {
      name: "Jananidhi",
      description: "The NYCS Jananidhi Deposit Scheme offers competitive interest rates on fixed deposits for both regular investors and senior citizens.",
      imageUrl: "/Dashboard/Jananidhi.png",
      path: '/dimensions/JanaNidhi'
    },
    // {
    //   name: "Bio Energy",
    //   description: "Sustainable energy initiatives promoting renewable resources and environmental conservation.",
    //   imageUrl: "Dashboard/bio-2.png",
    //   path: '/dimensions/Bioenergy'
    // },
    {
      name: "Yuva Expo",
      description: "YUVA Expo, an initiative by NYCS, is a dynamic platform designed to inspire and engage college students in event management and entrepreneurship.",
      imageUrl: "/Dashboard/Yuva-expo-logo.png",
      path: '/dimensions/YuvaExpo'
    },
    {
      name: "Yuva Sahkar",
      description: "Youth empowerment program focusing on skill development and entrepreneurship opportunities.",
      imageUrl: "/Dashboard/yuva-sahakar.png",
      path: '/dimensions/YuvaSahkar'
    }
  ];
  const joinSteps = [
    "Fill the Application Form",
    "You can buy 1 share to a maximum of 10 shares at ₹100 per share.",
    "Saving Account to be opened with ₹500.",
    "₹100 for the enrollment process fee.",
    "Minimum Investment: ₹700 to ₹1600.",
    "All payments to be made digitally.",
  ];
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100
      }
    }
  };
  // Carousel settings
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };


  const responsiveCarousel = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 1200 }, items: 3 },
    desktop: { breakpoint: { max: 1200, min: 900 }, items: 2 },
    tablet: { breakpoint: { max: 900, min: 600 }, items: 1 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 }
  };
  // Dummy data for events, videos, and images
  const events = ["/img-1.jpg", "/img-2.jpg", "/img-3.jpg"];
  const videos = ["/video-1.mp4", "/video-2.mp4", "/video-3.mp4"];
  const images = ["/Events/img-1.jpg", "/Events/img-2.jpg", "/Events/img-3.jpg", "/Events/img-4.jpg", "/Events/img-5.jpg", "/Events/img-6.jpg", "/Events/img-7.jpg", "/Events/img-8.jpg", "/Events/img-9.jpg", "/Events/img-10.jpg"];
  const navigate = useNavigate();
  return (
    <div style={{
      margin: 0,
      padding: 0,
      width: "100%"
    }}>
      <CarouselSlider />

      <Box sx={{
        py: 8,
        // background: 'linear-gradient(to right, #f3f4f6, #e5e7eb)', // Wrap inside quotes
        overflow: 'hidden'
      }}>

        {/* First Section: Text on Left, Image on Right */}
        <Box sx={{ py: 4 }}>
          {/* First Section */}
          <Container
            maxWidth="lg"
            sx={{
              py: 8,
              background: 'linear-gradient(to right, rgba(241,245,249,0.5), rgba(248,250,252,0.5))',
              borderRadius: 4,
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'
            }}
          >
            <Grid
              container
              spacing={4}
              alignItems="center"
              direction={isMobile ? 'column-reverse' : 'row'}
            >
              <Grid item xs={12} md={6}>
                <Fade in timeout={1000}>
                  <Box>
                    <Typography
                      variant="h3"
                      gutterBottom
                      sx={{
                        fontWeight: 700,
                        background: 'linear-gradient(to right, #1976d2, #512da8)',
                        backgroundClip: 'text',
                        textFillColor: 'transparent',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        mb: 3,
                        textAlign: isMobile ? 'center' : 'left'
                      }}
                    >
                      Empowering Youth
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{
                        color: 'text.secondary',
                        fontSize: '1.1rem',
                        lineHeight: 1.8,
                        mb: 4,
                        textAlign: isMobile ? 'center' : 'left'
                      }}
                    >
                      The <strong>National Youth Cooperative Society (NYCS)</strong> empowers youth through self-employment, skill development, and socio-economic initiatives. The NYCS Surat website highlights local programs, application forms, events, and resources, fostering community growth. Dedicated to innovation and self-reliance, NYCS Surat connects individuals with opportunities to create a brighter, sustainable future.
                    </Typography>
                  </Box>
                </Fade>
              </Grid>

              <Grid item xs={12} md={6}>
                <Zoom in timeout={1000}>
                  <Box
                    sx={{
                      position: 'relative',
                      p: 2,
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(45deg, rgba(25,118,210,0.1), rgba(81,45,168,0.1))',
                        borderRadius: 4,
                        transform: 'rotate(-3deg)',
                        zIndex: 0
                      }
                    }}
                  >
                    <Box
                      component="img"
                      src="/students-1.jpg"
                      alt="Youth Empowerment"
                      sx={{
                        width: '100%',
                        borderRadius: 4,
                        boxShadow: theme.shadows[10],
                        position: 'relative',
                        zIndex: 1,
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                          transform: 'scale(1.03)'
                        }
                      }}
                    />
                  </Box>
                </Zoom>
              </Grid>
            </Grid>
          </Container>

          {/* Second Section */}
          <Container
            maxWidth="lg"
            sx={{
              mt: 8,
              py: 8,
              background: 'linear-gradient(to right, rgba(241,245,249,0.5), rgba(248,250,252,0.5))',
              borderRadius: 4,
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'
            }}
          >
            <Grid
              container
              spacing={4}
              alignItems="center"
              direction={isMobile ? 'column' : 'row'}
            >
              <Grid item xs={12} md={6}>
                <Zoom in timeout={1000}>
                  <Box
                    sx={{
                      position: 'relative',
                      p: 2,
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(45deg, rgba(25,118,210,0.1), rgba(81,45,168,0.1))',
                        borderRadius: 4,
                        transform: 'rotate(-3deg)',
                        zIndex: 0
                      }
                    }}
                  >
                    <Box
                      component="img"
                      src="/yuva-1.jpg"
                      alt="Community Development"
                      sx={{
                        width: '100%',
                        borderRadius: 4,
                        boxShadow: theme.shadows[10],
                        position: 'relative',
                        zIndex: 1,
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                          transform: 'scale(1.03)'
                        }
                      }}
                    />
                  </Box>
                </Zoom>
              </Grid>

              <Grid item xs={12} md={6}>
                <Fade in timeout={1000}>
                  <Box>
                    <Typography
                      variant="h3"
                      gutterBottom
                      sx={{
                        fontWeight: 700,
                        background: 'linear-gradient(to right, #1976d2, #512da8)',
                        backgroundClip: 'text',
                        textFillColor: 'transparent',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        mb: 3,
                        textAlign: isMobile ? 'center' : 'left'
                      }}
                    >
                      Community Impact
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{
                        color: 'text.secondary',
                        fontSize: '1.1rem',
                        lineHeight: 1.8,
                        mb: 4,
                        textAlign: isMobile ? 'center' : 'left'
                      }}
                    >
                      At <strong>NYCS</strong>, we are committed to transforming youth potential into economic success. Through our comprehensive programs, we provide practical training, mentorship, and resources that enable young individuals to become self-reliant entrepreneurs and skilled professionals. Our collaborative approach ensures sustainable development and creates lasting positive impact in communities across India.
                    </Typography>
                  </Box>
                </Fade>
              </Grid>
            </Grid>
          </Container>


        </Box>
        {/* third section */}
        <Container
          maxWidth="lg"
          sx={{
            py: 8,
            background: 'linear-gradient(to right, rgba(241,245,249,0.5), rgba(248,250,252,0.5))',
            borderRadius: 4,
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
            mt: "20px"
          }}
        >
          <Grid container spacing={4} alignItems="center" direction={isMobile ? 'column-reverse' : 'row'}>
            <Grid item xs={12} md={6}>
              <Fade in timeout={1000}>
                <Box>
                  <Typography
                    variant="h3"
                    gutterBottom
                    sx={{
                      fontWeight: 700,
                      background: 'linear-gradient(to right, #1976d2, #512da8)',
                      backgroundClip: 'text',
                      textFillColor: 'transparent',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      mb: 3,
                      textAlign: isMobile ? 'center' : 'left'
                    }}
                  >
                    Why should "Yuva" join NYCS?
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                      fontSize: '1.1rem',
                      lineHeight: 1.8,
                      mb: 4,
                      textAlign: isMobile ? 'center' : 'left'
                    }}
                  >
                    The <strong>National Youth Cooperative Society (NYCS)</strong> is committed to empowering the youth by addressing their key challenges. Whether it's career guidance, job opportunities, business support, project funding, mentorship, or micro-financing—NYCS provides solutions to help young individuals thrive. Our platform fosters innovation, self-reliance, and a strong community network, ensuring that every "Yuva" has the resources to build a successful and sustainable future.
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      mt: 5
                    }}
                  >
                    <Button
                      variant="contained"
                      size="large"
                      sx={{
                        borderRadius: 2,
                        py: 1.5,
                        px: 4,
                        textTransform: 'none',
                        fontSize: '1.1rem',
                        background: 'linear-gradient(to right, #1976d2, #512da8)',
                        '&:hover': {
                          background: 'linear-gradient(to right, #1565c0, #4527a0)'
                        }
                      }}
                      onClick={() => navigate("/StudentChapter")}
                    >
                      Become a Member
                    </Button>
                  </Box>

                </Box>
                {/* Responsive Button Section */}
              </Fade>
            </Grid>

            <Grid item xs={12} md={6}>
              <Zoom in timeout={1000}>
                <Box
                  sx={{
                    position: 'relative',
                    p: 2,
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: 'linear-gradient(45deg, rgba(25,118,210,0.1), rgba(81,45,168,0.1))',
                      borderRadius: 4,
                      transform: 'rotate(-3deg)',
                      zIndex: 0
                    }
                  }}
                >
                  <Box
                    component="img"
                    src="/img-2.jpg"
                    alt="Youth Empowerment"
                    sx={{
                      width: '100%',
                      borderRadius: 4,
                      boxShadow: theme.shadows[10],
                      position: 'relative',
                      zIndex: 1,
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'scale(1.03)'
                      }
                    }}
                  />
                </Box>
              </Zoom>
            </Grid>
          </Grid>
        </Container>
        {/* third section for what is jananidhi */}
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', py: 4 }}>
          <Container
            maxWidth="lg"
            sx={{
              py: 8,
              background: 'linear-gradient(to right, rgba(241,245,249,0.5), rgba(248,250,252,0.5))',
              borderRadius: 4,
              my: 4,
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'
            }}
          >
            <Grid
              container
              spacing={4}
              alignItems="center"
              direction={isMobile ? 'column-reverse' : 'row'}
            >
              <Grid item xs={12} md={6}>
                <Slide
                  direction="right"
                  in={true}
                  timeout={1000}
                  mountOnEnter
                  unmountOnExit
                >
                  <Box>
                    <Typography
                      variant="h3"
                      gutterBottom
                      sx={{
                        fontWeight: 700,
                        background: 'linear-gradient(to right, #1976d2, #512da8)',
                        backgroundClip: 'text',
                        textFillColor: 'transparent',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        mb: 3
                      }}
                    >
                      What is Jananidhi?
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{
                        color: 'text.secondary',
                        fontSize: '1.1rem',
                        lineHeight: 1.8,
                        mb: 4
                      }}
                    >
                      With the objective of rebuilding the nation through youth empowerment, NYCS considers cooperatives as a model of business enterprise and is making every effort to promote entrepreneurship through the same. Financial activity is the mainstay of any business. In this direction, NYCS India has set up centres across the country under the name of Jana Nidhi to provide need-based micro finances to the youth for taking up income-generating activities and opportunities through self-employment and entrepreneurship.

                    </Typography>

                    <Button
                      variant="contained"
                      size="large"
                      sx={{
                        borderRadius: 2,
                        py: 1.5,
                        px: 4,
                        textTransform: 'none',

                        fontSize: '1.1rem',
                        background: 'linear-gradient(to right, #1976d2, #512da8)',
                        '&:hover': {
                          background: 'linear-gradient(to right, #1565c0, #4527a0)'
                        }
                      }}
                      onClick={() => navigate("/JanaNidhiForm")}
                    >
                      Learn More
                    </Button>
                  </Box>
                </Slide>
              </Grid>

              <Grid item xs={12} md={6}>
                <Fade in={true} timeout={1500}>
                  <Box
                    sx={{
                      position: 'relative',
                      p: 2,
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(45deg, rgba(25,118,210,0.1), rgba(81,45,168,0.1))',
                        borderRadius: 4,
                        transform: 'rotate(-3deg)',
                        zIndex: 0
                      }
                    }}
                  >
                    <Box
                      component="img"
                      src="/jananidhi.jpg"
                      alt="Community Development"
                      sx={{
                        width: '100%',
                        borderRadius: 4,
                        boxShadow: theme.shadows[10],
                        position: 'relative',
                        zIndex: 1,
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                          transform: 'scale(1.03)'
                        }
                      }}
                    />

                  </Box>
                </Fade>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Grid container spacing={4} justifyContent="center" sx={{ px: 2 }}>
          {stats.map((stat, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <StatsCard>
                <CardContent sx={{ textAlign: "center" }}>
                  <IconBox>{stat.icon}</IconBox>
                  <Typography
                    variant="h4"
                    sx={{
                      mt: 2,
                      background: "linear-gradient(to right, #1565c0, #4527a0)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontWeight: "bold",
                      mb: 1
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography variant="h6" sx={{ color: "#333", mb: 1 }}>
                    {stat.label}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {stat.description}
                  </Typography>
                </CardContent>
              </StatsCard>
            </Grid>
          ))}
        </Grid>

        {/* How to join nycs section */}
        <Box sx={{ minHeight: '50vh', display: 'flex', alignItems: 'center', py: 4 }}>
          <Container
            maxWidth="lg"
            sx={{
              py: 8,
              background: 'linear-gradient(to right, rgba(241,245,249,0.5), rgba(248,250,252,0.5))',
              borderRadius: 4,
              my: 4,
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'
            }}
          >
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                fontWeight: 700,
                background: 'linear-gradient(to right, #1976d2, #512da8)',
                backgroundClip: 'text',
                textFillColor: 'transparent',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mb: 5,
                textAlign: isMobile ? 'center' : 'left'
              }}
            >
              How to Join NYCS ?
            </Typography>

            <Grid container spacing={2} justifyContent="center">
              {joinSteps.map((step, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Box display="flex" alignItems="center">
                    <ListItemIcon>
                      <CheckCircleIcon sx={{ color: "green" }} />
                    </ListItemIcon>
                    <Typography variant="body1" sx={{ color: "black" }}>
                      {step}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* Responsive Button Section */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                mt: 5
              }}
            >
              <Button
                variant="contained"
                size="large"
                sx={{
                  borderRadius: 2,
                  py: 1.5,
                  px: 4,
                  textTransform: 'none',
                  fontSize: '1.1rem',
                  background: 'linear-gradient(to right, #1976d2, #512da8)',
                  '&:hover': {
                    background: 'linear-gradient(to right, #1565c0, #4527a0)'
                  }
                }}
                onClick={() => navigate("/FormApplication")}
              >
                Become a Member
              </Button>
            </Box>
          </Container>
        </Box>

        {/* <Container
          maxWidth="lg"
          sx={{
            mt: 8,
            py: 8,
            background: 'linear-gradient(to right, rgba(241,245,249,0.5), rgba(248,250,252,0.5))',
            borderRadius: 4,
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'
          }}
        >

      <BlogCardCarousel />
        </Container> */}


        {/* fourth section */}
        <Container
          maxWidth="lg"
          sx={{
            mt: 8,
            py: 8,
            background: 'linear-gradient(to right, rgba(241,245,249,0.5), rgba(248,250,252,0.5))',
            borderRadius: 4,
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'
          }}
        >
          <Grid
            container
            spacing={4}
            alignItems="center"
            direction={isMobile ? 'column' : 'row'}
          >
            <Grid item xs={12} md={6}>
              <Zoom in timeout={1000}>
                <Box
                  sx={{
                    position: 'relative',
                    p: 2,
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: 'linear-gradient(45deg, rgba(25,118,210,0.1), rgba(81,45,168,0.1))',
                      borderRadius: 4,
                      transform: 'rotate(-3deg)',
                      zIndex: 0
                    }
                  }}
                >
                  <Box
                    component="img"
                    src="/Events/img-2.jpg"
                    alt="Community Development"
                    sx={{
                      width: '100%',
                      borderRadius: 4,
                      boxShadow: theme.shadows[10],
                      position: 'relative',
                      zIndex: 1,
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'scale(1.03)'
                      }
                    }}
                  />
                </Box>
              </Zoom>
            </Grid>

            <Grid item xs={12} md={6}>
              <Fade in timeout={1000}>
                <Box>
                  <Typography
                    variant="h3"
                    gutterBottom
                    sx={{
                      fontWeight: 700,
                      background: 'linear-gradient(to right, #1976d2, #512da8)',
                      backgroundClip: 'text',
                      textFillColor: 'transparent',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      mb: 3,
                      textAlign: isMobile ? 'center' : 'left'
                    }}
                  >
                    Students Chapters
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                      fontSize: '1.1rem',
                      lineHeight: 1.8,
                      mb: 4,
                      textAlign: isMobile ? 'center' : 'left'
                    }}
                  >
                    The NYCS Students Chapters empowers students with practical skills through initiatives like the Masters Training Program, Service Sector Opportunities, and Selling & Marketing Sector Training. With a seamless digital enrollment process and "Learning with Earning" opportunities, we bridge the gap between education and employment.
                  </Typography>
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      borderRadius: 2,
                      py: 1.5,
                      px: 4,
                      textTransform: 'none',
                      fontSize: '1.1rem',
                      background: 'linear-gradient(to right, #1976d2, #512da8)',
                      '&:hover': {
                        background: 'linear-gradient(to right, #1565c0, #4527a0)'
                      }
                    }}
                    onClick={() => navigate("/StudentChapter")}
                  >
                    Learn More
                  </Button>
                </Box>
              </Fade>
            </Grid>
          </Grid>
        </Container>


        {/* our programs */}
        <Container
          maxWidth="lg"
          sx={{
            mt: 8,
            py: 1,
            background: 'linear-gradient(to right, rgba(241,245,249,0.5), rgba(248,250,252,0.5))',
            borderRadius: 4,
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'
          }}
        >
          <OurPrograms programs={programs} />
        </Container>
        {/* blog slider */}
        {/* <BlogSlider /> */}
        {/* Image Gallery */}
        <Container maxWidth="lg" sx={{ mt: 8, overflow: "hidden" }}>


          {/* Scrolling Container */}
          <Container maxWidth="lg" sx={{ mt: 8, overflow: "hidden" }}>
            <Typography
              variant="h3"
              align="center"
              gutterBottom
              sx={{
                background: "linear-gradient(to right, #1565c0, #4527a0)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",

                fontWeight: "bold",
                color: "#333",

                mb: 4,
              }}
            >
              Our Gallery
            </Typography>

            {/* Scrolling Wrapper */}
            <Box
              sx={{
                display: "flex",
                overflow: "hidden",
                whiteSpace: "nowrap",
                position: "relative",
                width: "100%",
              }}
            >
              <motion.div
                style={{
                  display: "flex",
                  gap: "20px",
                  flexWrap: "nowrap",
                  minWidth: "max-content", // Prevent wrapping
                }}
                animate={{
                  x: ["0%", "-100%"], // Moves from start to end
                }}
                transition={{
                  ease: "linear",
                  duration: 80,
                  repeat: Infinity, // Infinite loop
                }}
              >
                {/* Duplicate images for seamless loop */}
                {[...images, ...images].map((img, index) => (
                  <Box
                    key={index}
                    component="img"
                    src={img}
                    alt={`Gallery ${index + 1}`}
                    sx={{
                      width: "250px",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "12px",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    }}
                  />
                ))}
              </motion.div>
            </Box>
          </Container>
        </Container>
      </Box>
    </div>
  );
}
